import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog"; // Importamos el modal
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import LEAsociarPedCtnModal from "./LEAsociarPedCtnModal";
import { MultiStateCheckbox } from "primereact/multistatecheckbox";
import { obtenerTodo } from "../Utils/seleccionproductosxpedidosxcontenedor";
import { fetchWithAuth, API_URL } from "../Componentes/fetchWithAuth";

//const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const AsociarPedContenedorModal = ({
  language,
  isOpen,
  onClose,
  contenedor,
}) => {
  // 🔹 Se agregan props para abrir/cerrar
  //console.log("📦 Contenedor recibido en el modal:", contenedor); // 🔥 Agregar este log

  const [pedidos, setPedidos] = useState([]);
  const [selectedPedidos, setSelectedPedidos] = useState([]);
  //const [cantidadCajas, setCantidadCajas] = useState({});
  //const [pesoCajas, setPesoCajas] = useState({});
  const [modalListasVisible, setModalListasVisible] = useState(false); // ✅ Nuevo modal
  const [pedidoSeleccionado, setPedidoSeleccionado] = useState(null); // ✅ Pedido actual
  const [estadoCheckPedidos, setEstadoCheckPedidos] = useState({});

  const translations = {
    es: {
      title: "Asociar Pedidos al Contenedor",
      resumen: "Resumen del Contenedor",
      id: "ID",
      estado: "Estado del Contenedor",
      pedidosTitulo: "Listado de Pedidos",
      seleccionar: "Seleccionar",
      cliente: "Cliente",
      estadoPedido: "Estado Pedido",
      cajasPedido: "Cajas Pedido",
      cajasRecibidas: "Cajas Recibidas",
      cajasPendientes: "Cajas Pendientes",
      cantidadAsociar: "Cajas a Asociar",
      pesoAsociar: "Peso Asociado (kg)",
      fechaPedido: "Fecha Pedido",
      botonAsociar: "Asociar Pedidos",
      Marca: "Marca",
    },
  };

  const estadosCheckbox = [
    { value: "checked", icon: "pi pi-check" },
    { value: "unchecked", icon: "pi pi-times" },
    { value: "indeterminate", icon: "pi pi-minus" },
  ];

  const {
    title,
    pedidosTitulo,
    seleccionar,
    cliente,
    estadoPedido,
    botonAsociar,
    Marca,
    id,
    estado,
  } = translations[language] || translations["es"];

  useEffect(() => {
    if (isOpen) {
      // 🔹 Solo carga datos si el modal está abierto

      fetchWithAuth(`${API_URL}/api/asociar-lista-pedidos`)
        .then((res) => res.json())
        .then((data) => setPedidos(data))
        .catch((err) => console.error("Error al cargar los pedidos:", err));
    }
  }, [contenedor, isOpen]);

  //const handleAbrirListas = (pedido) => {
  //  setPedidoSeleccionado(pedido);
  //  setModalListasVisible(true);
  //};
  const handleAbrirListas = (pedido) => {
    const fueSeleccionado = selectedPedidos.some(
      (p) => p.idpedido === pedido.idpedido,
    );
    setPedidoSeleccionado({ ...pedido, seleccionado: fueSeleccionado });
    setModalListasVisible(true);
    console.log(
      "📦 Abriendo listas de pedido:",
      pedido.idpedido,
      "¿Está seleccionado?",
      fueSeleccionado,
    );
  };

  const actualizarEstadoCheck = (pedidoId, cajasSeleccionadas, totalCajas) => {
    let estado = "unchecked";

    if (cajasSeleccionadas === totalCajas && totalCajas > 0) estado = "checked";
    else if (cajasSeleccionadas > 0) estado = "indeterminate";

    setEstadoCheckPedidos((prev) => ({
      ...prev,
      [pedidoId]: { estado },
    }));

    console.log(`🧩 Pedido ${pedidoId}:`, {
      cajasSeleccionadas,
      totalCajas,
      estado,
    });
  };

  const asociarPedidos = async () => {
    const seleccionFinal = obtenerTodo();

    if (seleccionFinal.length === 0) {
      alert("⚠️ No hay productos seleccionados para asociar.");
      return;
    }

    console.log("📦 Lista enviada al SP:", seleccionFinal);

    try {
      const response = await fetch(`${API_URL}/asociar-listas-empaque`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ lista: seleccionFinal }),
      });

      const result = await response.json();

      if (result.status === "ok") {
        alert("Listas de empaque asociadas correctamente.");
        setSelectedPedidos([]);
        onClose();
      } else {
        alert(`Error: ${result.message}`);
        console.error(result);
      }
    } catch (error) {
      console.error("Error al enviar al backend:", error);
      alert("Error de red o servidor.");
    }
  };

  // ⚠️ Esto es lo que fuerza el render cuando cambia estadoCheckPedidos
  const dummy = Object.values(estadoCheckPedidos)
    .map((e) => e.estado)
    .join(",");

  return (
    <Dialog
      header={title}
      visible={isOpen} // 🔹 Controla si el modal está abierto
      style={{ width: "60vw" }}
      modal
      onHide={onClose} // 🔹 Se cierra el modal cuando el usuario lo cierra
    >
      {contenedor ? (
        <div>
          <p>
            <strong>{id}:</strong> {contenedor.IdContenedor}
          </p>
          <p>
            <strong>{estado}:</strong> {contenedor.sNombreEstadoContenedor}
          </p>
        </div>
      ) : (
        <p>Cargando información del contenedor...</p>
      )}

      {/* Listado de Pedidos */}
      <h2>{pedidosTitulo}</h2>

      <DataTable value={pedidos} responsiveLayout="scroll" key={dummy}>
        <Column
          header={seleccionar}
          body={(rowData) => (
            // <Checkbox
            //  onChange={(e) => handlePedidoSelection(e, rowData)}
            // checked={selectedPedidos.some((p) => p.idpedido === rowData.idpedido)}
            ///>
            <MultiStateCheckbox
              value={
                estadoCheckPedidos[rowData.idpedido]?.estado || "unchecked"
              }
              options={estadosCheckbox}
              optionValue="value"
              className="p-checkbox-sm"
              readOnly
            />
          )}
        />
        <Column field="idpedido" header="ID Pedido" />
        <Column field="sMarca" header={Marca} />
        <Column field="sNombreCliente" header={cliente} />
        <Column field="sNombreEstadoPedido" header={estadoPedido} />

        {/* ✅ BOTÓN PARA ABRIR MODAL DE LISTAS DE EMPAQUE */}
        <Column
          header=""
          body={(rowData) => (
            <Button
              id={`btn-bl-ver-listas-${rowData.idpedido}`} // ID único por fila
              icon="pi pi-truck"
              className="p-button-rounded p-button-text"
              tooltip="Ver Listas de Empaque"
              onClick={() => handleAbrirListas(rowData)}
            />
          )}
        />
      </DataTable>

      {/* Botón de confirmación */}
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <Button
          id="btn-bl-asociar-confirmar"
          label={botonAsociar}
          icon="pi pi-check"
          className="p-button-success"
          onClick={asociarPedidos}
        />
      </div>
      {/* ✅ MODAL SECUNDARIO */}
      {pedidoSeleccionado && (
        <LEAsociarPedCtnModal
          visible={modalListasVisible}
          onHide={() => setModalListasVisible(false)}
          pedido={pedidoSeleccionado}
          contenedor={contenedor} //paso el contenedor para que el otro modal lo vea
          onEstadoCheckBoxes={actualizarEstadoCheck}
        />
      )}
    </Dialog>
  );
};

export default AsociarPedContenedorModal;
